import { Card } from 'antd';
import styled from 'styled-components';
export const ReportViewCard = styled(Card)`
  max-width: 890px;
  margin-top: 0px !important;
`;